/** Opção de seleção devolvida pelos GET de apoio da Nova Obra (HU 2519). */
export interface ObraEmbarcacaoOpcao {
  id: string;
  nome: string;
}

export interface ObraLocalOpcao {
  id: string;
  codigo: string;
  nome: string;
}

export interface ObraStatusOpcao {
  id: string;
  codigo: string;
  descricao: string;
  /** RN05: só os status com `true` são oferecidos na criação. */
  disponivelNaCriacao: boolean;
}

export interface ObraUltimaObra {
  id: string;
  codigo: string;
  nome: string;
}

export interface ObraLimiteClasse {
  nome: string;
  /** `yyyy-MM-dd`. */
  vencimento: string;
  vencido: boolean;
}

/** Limite de `GET .../embarcacoes/:id/limites-classe` (HU 2549), ordenado pela data limite. */
export interface ObraLimiteClasseDetalhe {
  /** Enum da vistoria (`ESPECIAL`, `INTERMEDIARIA`, `ANUAL`, `BOTTOM`, `THRUSTER`, `PROPULSAO`, `FMEA`). */
  vistoria: string;
  /** Rótulo da vistoria (ex.: "Especial"). */
  descricao: string;
  /** `yyyy-MM-dd`. */
  dataLimite: string;
  /** Em relação a hoje. */
  vencido: boolean;
  /** Código do tipo de obra que renova ("101" | "102"); `null` = sem tipo associado. */
  renovaCom: string | null;
}

/** Classificação do período (`periodo_obra.etapa`); `null` quando o cadastro não classifica. */
export type PeriodoObraEtapa =
  "NAVEGACAO_ENTRADA" | "OBRA" | "TESTES" | "ACEITACAO" | "NAVEGACAO_SAIDA";

/** Tipo de período devolvido por `GET /api/obras/periodos-obra` (HU 2523), já ordenado. */
export interface ObraPeriodoOpcao {
  id: string;
  descricao: string;
  etapa: PeriodoObraEtapa | null;
}

/** Bloco somente leitura "Informações da Embarcação". */
export interface ObraEmbarcacaoInformacoes {
  embarcacaoId: string;
  clienteAtual: string;
  /** `yyyy-MM-dd` ou vazio. */
  terminoContrato: string;
  tipoEmbarcacao: string;
  previsaoExtensaoContratual: string;
  /** `null` quando a embarcação não tem histórico: "Nenhuma obra registrada". */
  ultimaObra: ObraUltimaObra | null;
  limitesClasse: ObraLimiteClasse[];
}

/** Tipo de obra (coletor do Protheus) de `GET /api/obras/tipos-obra` (HU 2525). */
export interface TipoObraOpcao {
  id: string;
  codigo: string;
  nome: string;
  ativo: boolean;
}

/** Centro de custo vinculado à embarcação, de `GET .../embarcacoes/:id/centros-custo` (HU 2525). */
export interface CentroCustoOpcao {
  id: string;
  /** Código do Protheus; o sufixo X/Y identifica obra de embarcação / manutenção operacional. */
  centroCusto: string;
  descricao: string;
  /** Preenchido só nos CCs SubSea (ex.: "ABL SUBSEA"). */
  subgrupo: string;
  /** RN20: CC bloqueado nunca é oferecido. */
  bloqueado: boolean;
}

/** Enum `StatusFinanceiro` (sem endpoint; persistido como texto em `obra.status_financeiro`). */
export const STATUS_FINANCEIRO_VALUES = [
  "FEL_0",
  "FEL_1",
  "FEL_2",
  "FEL_3",
  "FEL_4",
  "EXECUCAO",
  "FECHAMENTO",
  "CONCLUIDA",
] as const;

export type StatusFinanceiro = (typeof STATUS_FINANCEIRO_VALUES)[number];

export const STATUS_FINANCEIRO_LABELS: Record<StatusFinanceiro, string> = {
  FEL_0: "FEL-0",
  FEL_1: "FEL-1",
  FEL_2: "FEL-2",
  FEL_3: "FEL-3",
  FEL_4: "FEL-4",
  EXECUCAO: "Execução",
  FECHAMENTO: "Fechamento",
  CONCLUIDA: "Concluída",
};

/** Estado de uma consulta de opções/dados da Nova Obra. */
export interface ObraQueryState<T> {
  status: "loading" | "success" | "error" | "forbidden";
  data: T;
  errorMessage: string | null;
}

/** Resposta do `POST /api/obras` (`201`). */
export interface CriarObraResultado {
  id: string;
  codigo: string;
}
